import React, { ReactElement } from 'react';

const SvgWishListHeaderHighlighted = (props: React.SVGProps<SVGSVGElement>): ReactElement => (
    <svg viewBox="0 0 30 30" height="30" width="30" fill="#5F9A8C" {...props}>
        <path
            d="M15 23c-5.667-3.63-8.5-6.974-8.5-10.031C6.5 9.707 8.879 8 11.229 8c1.502 0 2.775.683 3.77 1.864C15.994 8.685 17.268 8 18.772 8c2.35 0 4.729 1.707 4.729 4.969 0 3.057-2.833 6.4-8.5 10.03zM11.23 8.943c-1.884 0-3.785 1.365-3.785 4.025 0 2.985 4.367 6.864 7.556 8.885 3.173-2.027 7.56-5.9 7.56-8.885 0-2.435-1.797-4.025-3.789-4.025-1.991 0-2.67 1.246-3.136 1.821-.31.383-.52.78-.634 1.19-.127-.355-.342-.752-.647-1.19-.457-.657-1.241-1.82-3.125-1.82z"
            fillRule="evenodd"
        />
    </svg>
);

export default SvgWishListHeaderHighlighted;
